import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router';
import * as R from 'Router/routes';
import LockIcon from 'assets/icons/lock.svg?react';
import CardWithIcon from 'components/CardWithIcon/CardWithIcon';
import { TwButton } from 'components/TwButton/TwButton';
import usePSD2Guide from './usePSD2Guide';
import { useTranslation } from 'react-i18next';

function OrderedList() {
  const { t } = useTranslation();
  const guideItems = [
    t('psd2_guide:default.step_1'),
    t('psd2_guide:default.step_2'),
    t('psd2_guide:default.step_3'),
  ];
  return (
    <div className="p-5 bg-background-accent rounded-md w-full">
      <ol className="flex flex-col gap-4" data-test="psd2Guide-list">
        {guideItems.map((item, index) => (
          <li
            key={item}
            className="flex gap-4"
            data-test={`psd2Guide-element-${index}`}
          >
            <div
              className="flex justify-center items-center border-2 border-primary rounded-full h-7 w-7 flex-shrink-0 bg-background text-primary font-semibold"
              data-test={`psd2Guide-element-${index}-left`}
            >
              {index + 1}
            </div>
            <div data-test={`psd2Guide-element-${index}-right`}>{item}</div>
          </li>
        ))}
      </ol>
    </div>
  );
}

function PSD2Guide() {
  const { bankName, initPSD2Session, isManual, pending } = usePSD2Guide();
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>{t('psd2_guide:html_title')}</title>
      </Helmet>

      <CardWithIcon
        heading={
          <span data-test="psd2-guide-heading">
            {t('psd2_guide:title')}{' '}
            <span
              className="text-primary"
              data-test="psd2-guide-heading-bankName"
            >
              {bankName}
            </span>
          </span>
        }
        icon={<LockIcon data-test="psd2-guide-lock-icon" />}
        dataTest="psd2-guide-card"
      >
        <OrderedList />
        <div className="mx-auto lg:mx-0 w-full flex justify-center lg:justify-start">
          <TwButton
            onClick={initPSD2Session}
            data-test="continue"
            disabled={pending}
            pending={pending}
          >
            {t('psd2_guide:continue')}
          </TwButton>
        </div>
      </CardWithIcon>

      <Link
        type="button"
        className="flex text-primary mx-auto lg:mx-0 mb-10 hover:underline text-left w-fit"
        data-test="back"
        to={isManual ? R.MANUAL_PSD2_BANKS : R.PSD2_BANKS}
      >
        {t('psd2_guide:back')}
      </Link>
    </>
  );
}

export default PSD2Guide;
